import { createContext } from "react";

export const initialState = new Map();
export const initialActions = {};

export const SearchSelectionStateContext = createContext(initialState);
export const SearchSelectionActionsContext = createContext(initialActions);
